import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../formControls";

const CleanAuthInformation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();

      document.cookie.split(";").forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });

      navigate("/login");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return <Loader active={true} text="Cleaning Auth Information..." />;
};

export default CleanAuthInformation;
